import React from 'react'
import { View } from 'react-native'
import cn from '@ui/utils/cn'
import Icon from '@ui/elements/Icon/Icon'
import Typography from '@ui/typography'
import { IconBadgeProps } from './types'
import { sIconContainer } from './styles'

const sAbsolute = 'absolute items-center justify-center'

export default function IconBadge({ badge, text, ...props }: IconBadgeProps) {
  return (
    <View className={sIconContainer}>
      <Icon {...props} />
      {badge && (
        <View
          className={cn(sAbsolute, '-bottom-1 -right-1', badge.classNameBadge)}
        >
          <Icon size={16} {...badge} />
        </View>
      )}
      {text && (
        <View className={cn(sAbsolute, '-bottom-[6px] pl-[1px]')}>
          <Typography variant="H1" className="text-left text-[10px]">
            {text}
          </Typography>
        </View>
      )}
    </View>
  )
}
